import { FC } from "react";
import { Review } from "@types";
import { ReviewInfo } from "@components/ReviewInfo/ReviewInfo";
import { ReviewTextBlock } from "@components/ReviewTextBlock/ReviewTextBlock";
import { Avatar } from "@components/Avatar/Avatar";
import styles from "./ReviewBlock.module.css";

interface ReviewBlockProps {
  review: Review;
}

export const ReviewBlock: FC<ReviewBlockProps> = ({ review }) => {
  return (
    <div className={styles.reviewBlock}>
      <div className={styles.mainContent}>
        <div className={styles.reviewInfoRow}>
          <Avatar alt={`${review.author}'s avatar`} size="large" />
          <ReviewInfo
            rating={review.rating}
            userName={review.author}
            date={review.date}
            store={review.store}
            productLink={review.productLink}
          />
        </div>

        <ReviewTextBlock
          comment={review.comment}
          advantages={review.advantages}
          disadvantages={review.disadvantages}
          recommends={review.recommends}
          answer={review.answer}
          photos={review.photos}
          videos={review.videos}
        />
      </div>
    </div>
  );
};
